import { Box, Grid } from "@mui/material";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { ApplicationPaths } from "../components/api-authorization/ApiAuthorizationConstants";
import authService, { AuthenticationResultStatus } from "../components/api-authorization/AuthorizeService";

function navigateToReturnUrl(returnUrl) {
  // It's important that we do a replace here so that we remove the callback uri with the
  // fragment containing the tokens from the browser history.
  // window.history.pushState(null, null, returnUrl);
  window.location.replace(returnUrl);
}

export const LogoutPage = (props) => {
  const { t, i18n } = useTranslation();
  const logout = async () => {
    const result = await authService.logOut();
    switch (result.status) {
      case AuthenticationResultStatus.Success:
        navigateToReturnUrl(props.returnUrl ?? ApplicationPaths.Login);
        break;
      case AuthenticationResultStatus.Fail:
        this.setState({ message: result.message });
        break;
      default:
        throw new Error(`Invalid status result ${result.status}.`);
    }
  };

  useEffect(() => {
    logout();
  }, []);

  return (
    <Box>
      <Grid container className="container custom padding bottom-2" justifyContent="center">
        <Grid item>
          <h1>{t("processing_logout")}</h1>
        </Grid>
      </Grid>
    </Box>
  );
};
